export default "__VITE_ASSET__mFT9PEDQ__"